import { z } from 'zod';

import { type Carrier } from './carriers';

export const WebSocketMessageTypes = z.enum([
  'LOG_UPDATED',
  'EVENT',
  'SHOW_HIDE_STREAM',
  'ACTIVITY_EVENT_CREATED',
  'ACTIVITY_EVENT_REVIEWED',
  'STREAM_STATUS',
  'ROUTER_NETWORK_CHANGED',
]);
export type WebSocketMessageType = z.infer<typeof WebSocketMessageTypes>;

export interface StreamStatusData {
  streamId: string;
  status: 'reconnecting' | 'online';
  since?: string;
  lastError?: string;
}

export interface StreamStatusMessage {
  event: 'STREAM_STATUS';
  data: StreamStatusData;
}

export type RouterNetworkState = 'online' | 'offline' | 'degraded' | 'switching';
export type RouterNetworkEventType =
  | 'sim_switched'
  | 'link_down'
  | 'link_up'
  | 'flapping'
  | 'switch_requested'
  | 'switch_failed';
export type RouterNetworkChangeType =
  | RouterNetworkEventType
  | 'capacity_test_started'
  | 'capacity_test_finished'
  | 'primary_changed';

export interface RouterNetworkChangedData {
  routerId: string;
  patientId: string;
  type: RouterNetworkChangeType;
  state: RouterNetworkState;
  fromCarrier?: Carrier;
  toCarrier?: Carrier;
  onPrimary: boolean;
}

export interface RouterNetworkChangedMessage {
  event: 'ROUTER_NETWORK_CHANGED';
  data: RouterNetworkChangedData;
}

export interface LogUpdatedMessage<T = unknown> {
  event: 'LOG_UPDATED';
  data: T;
}

export const EventMessageCategorySchema = z.enum([
  'EVENT_CREATED',
  'EVENT_UPDATED',
  'MESSAGE_RECEIVED',
  'MATCHING_UPDATED',
]);
export type EventMessageCategory = z.infer<typeof EventMessageCategorySchema>;

export interface EventMessage<TEvent = unknown> {
  category: EventMessageCategory;
  event: TEvent;
}

export interface EventWsMessage<TEvent = unknown> {
  event: 'EVENT';
  data: EventMessage<TEvent>;
}
